import GetFireDepartmentByIdRequestModelBase from '../_generated/modelBases/get-fire-department-by-id-request-model-base';

export default class GetFireDepartmentByIdRequestModel extends GetFireDepartmentByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
